import { Access } from '../../enums';
import { Permission } from '../permission';

const RESIDENT_KEY = 'residents';
export const RESIDENTS = {
  /**
   * Right to Access the Residents Base-Data Menu
   */
  READ: new Permission({
    key: `${RESIDENT_KEY}:global:${Access.READ}`,
    description: 'Bewohner – Leserecht',
  }),

  /**
   * Right to Modify any Resident Base-Data data
   */
  WRITE: new Permission({
    key: `${RESIDENT_KEY}:global:${Access.WRITE}`,
    description: 'Bewohner - Schreibrecht',
  }),

  /**
   * Rights to Access / Modify Resident General (= Allgemein) Base-Data
   */
  GENERAL: {
    READ: new Permission({
      key: `${RESIDENT_KEY}:general:${Access.READ}`,
      description: 'Bewohner – Allgemein Leserecht',
    }),

    WRITE: new Permission({
      key: `${RESIDENT_KEY}:general:${Access.WRITE}`,
      description: 'Bewohner - Allgemein Schreibrecht',
    }),
  },

  /**
   * Rights to Access / Modify Resident Contract-Data
   */
  CONTRACT: {
    READ: new Permission({
      key: `${RESIDENT_KEY}:contract:${Access.READ}`,
      description: 'Bewohner-Vertragsdaten L',
    }),

    WRITE: new Permission({
      key: `${RESIDENT_KEY}:contract:${Access.WRITE}`,
      description: 'Bewohner-Vertragsdaten S',
    }),
  },

  /**
   * Rights to Access / Modify Resident Checklist data
   */
  CHECKLIST: {
    READ: new Permission({
      key: `${RESIDENT_KEY}:checklist:${Access.READ}`,
      description: 'Bewohner-Checkliste L',
    }),

    WRITE: new Permission({
      key: `${RESIDENT_KEY}:checklist:${Access.WRITE}`,
      description: 'Bewohner-Checkliste S',
    }),
  },

  /**
   * Rights to Access / Modify Resident Contacts data
   */
  CONTACTS: {
    READ: new Permission({
      key: `${RESIDENT_KEY}:contacts:${Access.READ}`,
      description: 'Bewohner-Angehörige/Kontakte L',
    }),

    WRITE: new Permission({
      key: `${RESIDENT_KEY}:contacts:${Access.WRITE}`,
      description: 'Bewohner-Angehörige/Kontakte S',
    }),
  },

  /**
   * Rights to Access / Modify Resident Document Management data
   */
  DOCUMENT_MANAGEMENT: {
    READ: new Permission({
      key: `${RESIDENT_KEY}:document-management:${Access.READ}`,
      description: 'Bewohner-Dokumentenmanagement L',
    }),

    WRITE: new Permission({
      key: `${RESIDENT_KEY}:document-management:${Access.WRITE}`,
      description: 'Bewohner-Dokumentenmanagement S',
    }),
  },

  /**
   * Rights to Access / Modify Resident Consultation data
   */
  CONSULTATION: {
    READ: new Permission({
      key: `${RESIDENT_KEY}:consultation:${Access.READ}`,
      description: 'Bewohner-Beratung L',
    }),

    WRITE: new Permission({
      key: `${RESIDENT_KEY}:consultation:${Access.WRITE}`,
      description: 'Bewohner-Beratung S',
    }),
  },

  UTILS: {
    READ: new Permission({
      key: `${RESIDENT_KEY}:utils:${Access.READ}`,
      description: 'Bewohner-Utensilien L',
    }),

    WRITE: new Permission({
      key: `${RESIDENT_KEY}:utils:${Access.WRITE}`,
      description: 'Bewohner-Utensilien S',
    }),
  },

  PASTORAL_CARE: {
    READ: new Permission({
      key: `${RESIDENT_KEY}:pastoral-care:${Access.READ}`,
      description: 'Bewohner-Seelsorge L',
    }),

    WRITE: new Permission({
      key: `${RESIDENT_KEY}:pastoral-care:${Access.WRITE}`,
      description: 'Bewohner-Seelsorge S',
    }),
  },

  FILES: {
    READ: new Permission({
      key: `${RESIDENT_KEY}:documents:${Access.READ}`,
      description: 'Bew. Dokumente – Leserecht',
    }),

    WRITE: new Permission({
      key: `${RESIDENT_KEY}:documents:${Access.WRITE}`,
      description: 'Bew. Dokumente - Schreibrecht',
    }),

    DELETE: new Permission({
      key: `${RESIDENT_KEY}:documents:${Access.DELETE}`,
      description: 'Bew. Dokumente - Löschrecht',
    }),
  },
};
